import { render, staticRenderFns } from "./NewsCenterDetails7.vue?vue&type=template&id=b91ea4ea&scoped=true"
import script from "./NewsCenterDetails7.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails7.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails7.vue?vue&type=style&index=0&id=b91ea4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ea4ea",
  null
  
)

export default component.exports